import { render, staticRenderFns } from "./AdvertisingModuleV1Manager.vue?vue&type=template&id=32578ee4&scoped=true"
import script from "./AdvertisingModuleV1Manager.vue?vue&type=script&lang=js"
export * from "./AdvertisingModuleV1Manager.vue?vue&type=script&lang=js"
import style0 from "./AdvertisingModuleV1Manager.vue?vue&type=style&index=0&id=32578ee4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32578ee4",
  null
  
)

export default component.exports